import axios from "axios";
import React, { useEffect, useState } from "react";
import { BiArrowBack } from "react-icons/bi";
import { useNavigate } from "react-router-dom";

const AllUniversityPricing = () => {
  const [universities, setUniversities] = useState([]);
  const [universityId, setUniversityId] = useState("");
  const [courseId, setCourseId] = useState("");
  const [courses, setCourses] = useState([]);
  const [semesterId, setSemesterId] = useState("");
  const [semesters, setSemesters] = useState([]);
  const [universityExamNotesPrice, setUniversityExamNotesPrice] = useState([]);

  const navigate = useNavigate();
  const API_BASE_URL = process.env.REACT_APP_API_BASEURL;

  const handleAddPrice = () => {
    navigate("/exam-notes-pricing/add-university-pricing");
  };
  const handleViewAllPrice = () => {
    navigate("/exam-notes-pricing/all-university-pricing");
  };
  const handleGoBack = () => {
    navigate("/exam-notes-pricing");
  };

  useEffect(() => {
    axios
      .get(`${API_BASE_URL}/universities`)
      .then((response) => {
        const universitiesData = response.data?.data || [];
        setUniversities(universitiesData);
      })
      .catch((error) => console.log(error));
  }, []);

  useEffect(() => {
    if (universityId) {
      axios
        .get(`${API_BASE_URL}/all-courses/${universityId}`)
        .then((response) => {
          const coursesData = response.data?.data || [];
          setCourses(coursesData);
        })
        .catch((error) => {
          console.log(error);
        });
    }
  }, [universityId]);

  useEffect(() => {
    axios
      .get(`${API_BASE_URL}/semesters`)
      .then((response) => {
        const semesterData = response.data?.data || [];
        setSemesters(semesterData);
      })
      .catch((error) => {
        console.log(error);
      });
  }, []);
  const handleSubmit = (e) => {
    e.preventDefault();

    axios
      .get(
        `${API_BASE_URL}/pricing/exam-notes?courseId=${courseId}&semesterId=${semesterId}`,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        }
      )
      .then((result) => {
        console.log(result?.data?.data);
        const data = result?.data?.data;
        setUniversityExamNotesPrice(data);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const handleEdit = (id) => {
    navigate(`/exam-notes-pricing/edit-university-pricing/${id}`);
  };

  const handleDelete = (id) => {
    const confirm = window.confirm("Are you sure you want to delete ? ");
    if (confirm) {
      axios
        .delete(`${API_BASE_URL}/admin/pricing/exam-notes/${id}`, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        })
        .then((result) => {
          console.log(result);
          alert("University exam notes price deleted successfully.");
        })
        .catch((error) => {
          console.log(error);
          alert("Error while deleting.")
        });
    }
  };

  return (
    <div id="allcollegenotes-inner-wrapper">
      <BiArrowBack
        onClick={handleGoBack}
        className="left-arrow-icon mt-3"
        style={{
          cursor: "pointer",
          marginLeft: "10px",
          fontSize: "25px",
          color: "#000", // Customize the color as needed
        }}
      />
      <div className="allcollegenotes-header-div">
        <h5>All University Exam Notes Price</h5>

        <div className="allcollegenotes-header-btns">
          <button className="add-college-note-btn" onClick={handleAddPrice}>
            + Add Price
          </button>
          <button
            className="all-college-notes-btn"
            onClick={handleViewAllPrice}
          >
            All Price
          </button>
        </div>
      </div>

      <form onSubmit={handleSubmit} className="note-detail-form form-container">
        <div className="new-chapter-form-group">
          <label className="new-chapter-label">Select University</label>
          <select
            className="new-chapter-dropdown"
            value={universityId}
            onChange={(e) => setUniversityId(e.target.value)}
            required
          >
            <option value="">-Select University-</option>
            {universities.map((universitie, idx) => (
              <option key={idx} value={universitie._id}>
                {universitie.universityName}
              </option>
            ))}
          </select>
        </div>

        <div className="new-chapter-form-group">
          <label className="new-chapter-label">Course Name</label>
          <select
            className="new-chapter-dropdown"
            value={courseId}
            onChange={(e) => setCourseId(e.target.value)}
            required
          >
            <option value="">-Select Course-</option>
            {courses.map((course, idx) => (
              <option key={idx} value={course._id}>
                {course.courseName}
              </option>
            ))}
          </select>
        </div>

        <div className="new-chapter-form-group">
          <label className="new-chapter-label">Semester</label>
          <select
            className="new-chapter-dropdown"
            value={semesterId}
            onChange={(e) => setSemesterId(e.target.value)}
            required
          >
            <option value="">-Select Semester-</option>
            {semesters.map((semester, idx) => (
              <option key={idx} value={semester._id}>
                {semester.semesterName}
              </option>
            ))}
          </select>
        </div>

        <div className="form1-btns">
          <button className="btn-save">Search Price</button>
        </div>
      </form>

      <div className="allcollegenotes-table-container">
        <h5>All Price</h5>
        <table className="allcollegenotes-table">
          <thead>
            <tr>
              <th>S.No.</th>
              <th>Course Name</th>
              <th>Semester</th>
              <th>Price</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            {universityExamNotesPrice.map((item, idx) => (
              <tr key={idx}>
                <td>{idx + 1}</td>
                <td>{item.courseId?.courseName}</td>
                <td>{item.semesterId?.semesterName}</td>
                <td>{item.price}</td>
                <td className="table-action-icons">
                  <i
                    className="fa-solid fa-file-pen"
                    onClick={() => handleEdit(item._id)}
                  ></i>
                  &nbsp;&nbsp;
                  <i
                    className="fa-solid fa-trash-can"
                    onClick={() => handleDelete(item._id)}
                  ></i>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default AllUniversityPricing;
